// extracted by mini-css-extract-plugin
module.exports = {"page":"building_page__2CtbN","page__content":"building_page__content__32D0K"};